import { lazy } from 'react';
export const UploadMyStudyPage = lazy(() => import(/* webpackChunkName: "my-reports-upload" */ '.'));
export default UploadMyStudyPage;
